import axios from "axios";
import {useContext} from "react";
import api from "../interceptor/interceptor";

const LoginService = {
    async doLogin(data) {
        try {
            const response = await axios.post(
                'https://fleet.networkite.com/api/auth/login',
                data,
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            );
            const tokens = response.data;
            if (tokens?.token) localStorage.setItem('token', tokens.token);
            if (tokens?.smlToken) localStorage.setItem('smlToken', tokens.smlToken);
            if (tokens?.idToken) localStorage.setItem('idToken', tokens.idToken);
            if (tokens?.refreshToken) localStorage.setItem('refreshToken', tokens.refreshToken);
        } catch (e) {
            return {
                message: e.response.data.errors
            }
        }
    },
    async getUserDetails() {
        try {
            const response = await api.get('/api/user/detail');
            localStorage.setItem('user-details', JSON.stringify(response.data));
            return response.data;
        } catch (e) {
            return {
                message: e.response.data.errors
            }
        }
    }
}

export default LoginService;
